import React, { lazy, Suspense } from 'react';

const LazyUpdatePassword = lazy(() => import('./UpdatePassword'));

const UpdatePassword = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyUpdatePassword {...props} />
  </Suspense>
);

export default UpdatePassword;
